<template>
  <el-dialog
    lock-scroll
    :title="title"
    class="shipListDialog2"
    top="10px"
    :visible.sync="dialogShow"
    width="900px"
    :before-close="handleClose"
    style="z-index: 2017"
  >
    <div class="shipList">
      <div class="searchList">
        <el-form :inline="true" :model="formData" class="form-inline">
          <el-form-item>
            <el-select
              size="mini"
              v-model="hisState"
              @change="changeTory"
              placeholder=""
              style="width: 135px"
            >
              <el-option label="当前在船" value="1"></el-option>
              <el-option label="曾经在船" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="hisState != '1'">
            <el-date-picker
              type="date"
              size="mini"
              placeholder="开始时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="formData.beginDate"
              style="margin-right: 1rem"
            ></el-date-picker>
            <el-date-picker
              type="date"
              size="mini"
              placeholder="结束时间"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              v-model="formData.endDate"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-input
              size="mini"
              v-model="formData.userName"
              placeholder="姓名"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="search"
              >查询</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" class="addBtn" @click="submit"
              >确定</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="shipList"
        border
        header-row-class-name="other-header other-select"
        row-class-name="other-row"
        align="left"
        ref="multipleTable"
        max-height="456px"
        @select="hanleSelect"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="userName" label="船员名称"> </el-table-column>
        <el-table-column prop="crewTypeName" label="船员类型">
        </el-table-column>
        <el-table-column prop="postName" label="职务"> </el-table-column>
        <el-table-column prop="standardSalary" label="薪资标准">
        </el-table-column>
        <el-table-column prop="onCurrentShipFlag" label="在船标识">
          <template slot-scope="scope">
            <span
              v-if="scope.row.onCurrentShipFlag == '1'"
              style="color: #26c766"
              >当前在船</span
            >
            <span
              v-if="scope.row.onCurrentShipFlag != '1'"
              style="color: #fac832"
              >曾经在船</span
            >
          </template>
        </el-table-column>

        <!-- <el-table-column prop="shipId" label="mmsi"> </el-table-column> -->
      </el-table>
    </div>
    <div>
      <div class="other-check-page">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage1"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose" class="cancelBtn">取消</el-button>
      <el-button type="primary" @click="submit">确定</el-button>
    </div> -->
  </el-dialog>
</template>
<script>
import { selectUserInfoList } from "@/apis/index";
import moment from "moment";
export default {
  data() {
    return {
      title: "选择船员",
      dialogShow: false,
      shipList: [],
      chosedShip: [],
      oldChosed: [],
      formData: {
        shipName: "",
      },
      shipListAll: [],
      saShip: [],
      currentPage1: 1,
      pageNo: "1",
      total: 0,
      pageSize: 10,
      shipId: "",
      hisState: "1",
    };
  },
  methods: {
    changeTory() {
      if (this.hisState == "1") {
        this.$set(this.formData, "beginDate", "");
        this.$set(this.formData, "endDate", "");
      } else if (this.hisState == "2") {
        this.$set(
          this.formData,
          "beginDate",
          moment().subtract(5, "months").format("YYYY-MM-DD")
        );
      }
      this.search();
    },
    search() {
      this.pageNo = "1";
      this.seaShipAll();
    },
    showToggle(list, id) {
      this.shipId = id;
      // this.$set(this.formData, "shipName", list.shipName);
      // this.$set(this.formData, "shipId", list.shipName);
      this.dialogShow = true;
      console.log(list);
      this.chosedShip = list;
      this.oldChosed = JSON.parse(JSON.stringify(list));
      this.getShip();
      // this.getShipAll();
    },
    async getShip() {
      const data = {
        ...this.formData,
        shipId: this.shipId,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      const res = await selectUserInfoList(data);
      // console.log(res);

      res.data.resultList.forEach((val) => {
        val.staus = false;
      });
      this.shipList = res.data.resultList;
      this.total = res.data.rowCount;
      this.tableData = res.data.resultList;
      this.$nextTick(() => {
        this.shipList.forEach((el) => {
          this.oldChosed.forEach((val) => {
            if (el.userId == val.userId && val.postName == el.postName) {
              this.$refs.multipleTable.toggleRowSelection(el, true);
            }
          });
        });
      });
      this.shipList.forEach((el) => {
        this.oldChosed.forEach((val) => {
          if (el.userId == val.userId && val.postName == el.postName) {
            el.staus = true;
            if (val.id) {
              el.id = val.id;
            }
          }
        });
      });
      this.saShip = JSON.parse(JSON.stringify(this.shipList));
      if (!this.chosedShip.length) {
        this.$refs.multipleTable.clearSelection();
      }
    },
    async seaShipAll() {
      const data = {
        ...this.formData,
        shipId: this.shipId,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      const res = await selectUserInfoList(data);
      res.data.resultList.forEach((el) => {
        this.saShip.forEach((item) => {
          if (el.userId == item.userId && item.postName == el.postName) {
            el.staus = item.staus;
            if (this.saShip.id) {
              el.id = this.oldChosed.id;
              if (item.id) {
                el.id = item.id;
              }
              if (item.managementRatio) {
                el.managementRatio = item.managementRatio;
              }
            }
          }
        });
      });
      this.shipList = res.data.resultList;
      this.total = res.data.rowCount;
      this.tableData = res.data.resultList;
      this.$nextTick(() => {
        this.shipList.forEach((el) => {
          if (el.staus == true) {
            this.$refs.multipleTable.toggleRowSelection(el, true);
          }
        });
      });
    },
    handleCurrentChange(val) {
      this.currentPage1 = val;
      this.pageNo = val;
      this.getShip();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getShip();
    },

    handleSelectionChange(val) {
      this.chosedShip = val.filter((val) => {
        return typeof val != "string";
      });
    },
    hanleSelect(val, row) {
      this.saShip.forEach((item) => {
        if (row.userId == item.userId && row.postName == item.postName) {
          item.staus = !row.staus;
        }
      });
      row.staus = !row.staus;
      // console.log(row);
      if (row.staus) {
        this.oldChosed.push(row);
      } else {
        this.oldChosed.forEach((item, index) => {
          if (row.userId == item.userId && row.postName == item.postName) {
            this.oldChosed.splice(index, 1);
          }
        });
      }
    },
    submit() {
      // let choseShip = [];
      // this.saShip.forEach((item) => {
      //   if (item.staus == true) {
      //     choseShip.push(item);
      //   }
      // });
      // console.log(choseShip);

      if (!this.oldChosed.length) {
        this.$message.error("请选择要添加的船舶！");
        return;
      }
      this.$emit("choseShip", this.oldChosed);
      this.dialogShow = false;
      this.chosedShip = [];
    },
    handleClose() {
      this.dialogShow = false;
      this.chosedShip = [];
      this.oldChosed = [];
      this.formData = {
        shipName: "",
      };
    },
  },
};
</script>
<style lang="scss"></style>
